import i18n from '@/i18n';
import axios from 'axios';
import store from '@/store/index';
import { getSupportedLocales } from '@/util/i18n/supported-locales';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      locales: getSupportedLocales(),
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),

  },

  methods: {
    getLocale() {
      return i18n.locale;
    },

    updateUserLanguage(choosenLocale, code) {
      const newLocale = code ? choosenLocale : this.locales.find((locale) => locale.name === choosenLocale).code;
      axios.put(`/api/users/${this.user.id}/lang`, { lang: newLocale }).then(() => {
        store.dispatch('auth/me');
      }).catch((error) => {
        this.checkSessionErrorNotification(error);
      });
    },
  },
};
